<template>
    <a-modal
            title="LotId"
            :visible="queryLotIdWindow"
            width="80%"
            :maskClosable="false"
            :footer="null"
            :zIndex="99"
            @cancel="cancelQuerySearch">
        <a-row>
            <a-row type="flex" justify="space-between">
                <a-col>
                    <a-row type="flex" justify="start">
                        <a-col >
                            <a-input size="small" style="width: 150px" v-model="queryLotIdCode" @pressEnter="initLotId"/>
                        </a-col>
                        <img class="funcButton" src="../../../assets/img/search.png" width="22" height="22" @click="initLotId" :title="$t('batchReceive.Query')">
                        <img class="funcButton" src="../../../assets/img/refresh2.png" width="22" height="22" @click="resetLotId" :title="$t('pubGicSet.Clear')">
                    </a-row>
                </a-col>
                <a-col style="float: right">
                    <a-pagination
                            :pageSizeOptions="pageSizeOptions"
                            :showTotal="total => `${$t('generic.totalOf')} ${pagingSkuTotal} ${$t('generic.Records')}`"
                            size="small"
                            :total="pagingSkuTotal"
                            v-model="currentSkuVal"
                            :pageSize.sync="pagingSkuSize"
                            @change="tableLotIdChangePage"
                            @showSizeChange="onShowSizeLotIdChange"
                            showSizeChanger
                    />
                </a-col>
            </a-row>
            <a-row style="height: 65vh;" class="mt">
                <vxe-table
                        stripe
                        resizable
                        border
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow
                        :sort-config="{multiple: true, trigger: 'cell'}"
                        @cell-dblclick="checkedLotIds"
                        align="center"
                        height="auto"
                        size="mini"
                        :data="PagingGridSkuList">
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column field="orgCode" title="Org Code" width="200" sortable></vxe-table-column>
                    <vxe-table-column field="projectCode" title="Project Code" width="200" sortable></vxe-table-column>
                    <vxe-table-column field="sku" title="Sku" width="200" sortable></vxe-table-column>
                     <vxe-table-column field="lotId" title="Lot Id" width="200" sortable></vxe-table-column>
                    <vxe-table-column field="recQty" title="Rec Qty" width="200" sortable></vxe-table-column>
                    <vxe-table-column field="recBaseQty" title="Rec Base Qty" width="200" sortable></vxe-table-column>
                    <vxe-table-column field="allQty" title="All Qty" width="200" sortable></vxe-table-column>
                     <vxe-table-column field="allBaseQty" title="All Base Qty" width="200" sortable></vxe-table-column>
                    <vxe-table-column field="creator" :title="$t('generic.Creator')" width="200" sortable></vxe-table-column>
                    <vxe-table-column field="createTime" :title="$t('generic.CreateTime')" width="200" :formatter="formatTime" sortable></vxe-table-column>
                    <vxe-table-column field="modifier" :title="$t('generic.Modifier')" width="200" sortable></vxe-table-column>
                    <vxe-table-column field="modifyTime" :title="$t('generic.ModifyDate')" width="200" :formatter="formatTime" sortable></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-row>
    </a-modal>
</template>

<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
import XEUtils from "xe-utils";

export default{
    data(){
        return{
            queryLotIdWindow:false,
            pagingSkuTotal: 0, // 总数
            pagingSkuSize: 30, // 条数
            currentSkuVal: 1, // 当前选中的页数
            PagingGridSkuList: [],//明细列表数据
            pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
            queryLotIdCode:'',
        }
    },
    methods:{
        show(data){
            this.queryLotIdWindow = true
            this.queryLotIdCode = data
            this.initLotId()
        },
        tableLotIdChangePage(current) {
            this.currentSkuVal = current;
            this.queryLotId();
        },
        onShowSizeLotIdChange(current, pageSize) {//选择下拉框后触发事件
            this.currentSkuVal = current;
            this.pagingSkuSize = pageSize;
            this.queryLotId();
        },
        cancelQuerySearch(){
            this.queryLotIdWindow = false
        },
        initLotId(){
            this.currentSkuVal = 1;
            this.queryLotId();
        },
        queryLotId(){
            let params = {//配置查询条件
                currentVal: this.currentSkuVal,
                pagingSize: this.pagingSkuSize,
                lotId: this.queryLotIdCode
            }
            ajax.get(api.LOTIDINFOLIST,params).then(res=>{
                if(res.code == 200){
                    this.PagingGridSkuList = res.data;//列表
                    this.pagingSkuTotal = res.total;//总数
                    if(this.pagingSkuTotal == 1){//如果只有一条数据,自动填充
                        this.selectedLotId(this.PagingGridSkuList[0].lotId);
                    }
                }
            })
        },
        resetLotId(){//重置
            this.queryLotIdCode = "";
        },
        formatTime ({cellValue}) {
            return XEUtils.toDateString(cellValue, 'yyyy-MM-dd HH:ss:mm')
        },
        checkedLotIds({ row }) {//双击弹出修改窗口
            this.selectedLotId(row.lotId);
        },
        selectedLotId(lotId) {//双击弹出修改窗口
            this.queryLotIdWindow = false;
            this.$emit("checkedLotId", lotId);
        },

    }
}
</script>

<style scoped>
    .funcButton{
        cursor: pointer;
        margin-left: 5px;
    }
</style>